<script>
import { Line } from 'vue-chartjs';
export default {
  name: 'LineChart',
  extends: Line,
  props: {
    labels: {
      type: Array,
      required: true,
    },
    dataSets: {
      type: Array,
      required: true,
    },
    options: {
      type: Object,
      default: () => {},
    },
    label: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      defaultOptions: {
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
              gridLines: {
                display: true,
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                display: false,
              },
            },
          ],
        },
        legend: {
          display: true,
        },
        responsive: true,
        maintainAspectRatio: false,
        ...this.options,
      },
    };
  },
  computed: {
    chartData() {
      return {
        labels: this.labels,
        datasets: [
          {
            label: this.label,
            data: this.dataSets,
            backgroundColor: ['rgba(253, 62, 16, 0.14)'],
            borderColor: ['rgba(255, 108, 0, 1)'],
            borderWidth: 1,
          },
        ],
      };
    },
  },
  watch: {
    options: {
      handler() {
        Object.assign(this.defaultOptions, this.options);
      },
      deep: true,
    },
  },
  mounted() {
    this.renderChart(this.chartData, this.defaultOptions);
  },
};
</script>

<style scoped></style>
